import { useEffect, useState } from "react";
import { componentStyles } from "./live-board-homepage-first-fold-component.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureComponent from "/components/core/picture/picture-component";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import Title from "segments/desktop/core-components/title/title";
import classNames from "classnames";
import { XS } from "constants/sizes";
import { WHITE_COLOR_NAME, BRAND_PRIMARY_GREEN } from "styles/color-consts";
import DefaultProps from "./default-props";
import { LIVE_BOARD_OPEN_BUTTON_HOVERED, LIVE_BOARD_SCALED, LIVE_BOARD_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import { useInView } from "react-intersection-observer";
function LiveBoardHomepageFirstFoldComponent(props) {
  const [scaledEventSent, setScaledEventSent] = useState(false);
  const [liveBoardWrapperRef, liveBoardFullyInView] = useInView({
    threshold: 1.0,
    triggerOnce: true
  });
  const [playAnimation, setplayAnimation] = useState(false);

  const BOARDS_IMAGE_URL =
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/boards/v2_boards.png";
  const LIVE_BOARD_IMAGE =
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/boards/v2_demo_board.png";

  const { openLiveBoard, showLiveBoardImage, translate, liveBoardClosed } = props;
  const [showButton, setShowButton] = useState(liveBoardClosed);

  const liveBoardOpenButtonClicked = () => {
    openLiveBoard();
  };

  const liveBoardOpenButtonHovered = () => {
    trackEvent(LIVE_BOARD_OPEN_BUTTON_HOVERED);
  };

  const liveBoardClickEvent = () => {
    trackEvent(LIVE_BOARD_CLICKED);
  };

  const isAnimationPlayed = () => {
    if (!liveBoardClosed && playAnimation) {
      return true;
    }
  };

  const renderLiveBoardOpenButton = () => {
    return (
      <div className="open-button-content-wrapper" onMouseEnter={liveBoardOpenButtonHovered}>
        <div className="open-button-title-wrapper">
          <Title title={translate("liveBoard.openPopUpTitleText")} titleSize={XS} titleColor={BRAND_PRIMARY_GREEN} />
        </div>
        <div className="open-button-paragraph-wrapper">
          <Paragraph body={translate("liveBoard.openPopUpBodyText")} bodyColor={WHITE_COLOR_NAME} />
        </div>
        <div className="open-button-button-wrapper">
          <RegularButton
            buttonText={translate("liveBoard.openPopUpButtonText")}
            onClick={liveBoardOpenButtonClicked}
            color={WHITE_COLOR_NAME}
            isWithArrow={false}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (scaledEventSent) trackEvent(LIVE_BOARD_SCALED);
  }, [scaledEventSent]);

  useEffect(() => {
    if (liveBoardFullyInView) {
      setShowButton(true);
      setplayAnimation(true);
      setScaledEventSent(true);
    }
  }, [liveBoardFullyInView]);

  return (
    <div
      className={classNames("live-board-homepage-first-fold-component", {
        "animation-played": isAnimationPlayed(),
        "full-screen-board": !showLiveBoardImage,
        "live-board-closed": liveBoardClosed
      })}
    >
      <div className="boards-picture">
        <PictureComponent src={BOARDS_IMAGE_URL} />
      </div>

      <div className="live-board-wrapper" ref={liveBoardWrapperRef} onClick={liveBoardClickEvent}>
        <div className={classNames("animation-circle", { "hide-button": !showButton })} />
        <div className={classNames("open-button-wrapper", { "hide-button": !showButton })}>
          {renderLiveBoardOpenButton()}
        </div>
        <div className="live-board-image-wrapper">
          <PictureComponent src={LIVE_BOARD_IMAGE} />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
}

LiveBoardHomepageFirstFoldComponent.defaultProps = DefaultProps;

export default withGenericConfig(LiveBoardHomepageFirstFoldComponent);
